const $ba30e20475feac5a$export$bd0dac1968b402d7 = 3000;
const $ba30e20475feac5a$export$b4a06ec71d3d433c = "https://script.google.com/macros/s/AKfycbxoWFBG69ESjM56PdAYr8p19GniO9y-WhTjKNbMTFVfz_yAdxsnFGAJhFsdx4MYBSfm/exec";
const $ba30e20475feac5a$export$196440f71ed9f601 = 5000;
const $ba30e20475feac5a$export$2f54b3a07a353657 = "37 Folly View Road, Faringdon, England, SN7 7DQ";




const $bd02c871d9c5ba8e$var$timeout = function(s) {
    return new Promise(function(_, error) {
        setTimeout(function() {
            return error(`Request took too long, timeout after ${s} seconds`);
        }, s);
    });
};
const $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        const fetchPro = uploadData === true ? await fetch(url, {
            method: POST,
            headers: {
                "Content-Type": "appication/json"
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        const res = await Promise.race([
            fetchPro,
            $bd02c871d9c5ba8e$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        throw err;
    }
};


const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    heroSlider: {
        counter: 1,
        timer: (0, $ba30e20475feac5a$export$bd0dac1968b402d7),
        lastTime: 0,
        imagesSrc: []
    },
    tabbedComponent: {
        activeTab: null,
        contentTab: ""
    },
    sliderComponent: {
        curSlide: 0,
        dotDataSlide: 0,
        maxSlide: null
    },
    map: {
        coords: {
            lat: null,
            lon: null
        }
    }
};
function $0f1d4402dffacf5b$export$404675901f56ec25(imgList) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.imagesSrc = Array.from(imgList, (img)=>img.getAttribute("src"));
}
function $0f1d4402dffacf5b$export$322cd04d2c309b06(currentTime) {
    const deltaTime = currentTime - $0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.lastTime;
    if (deltaTime >= $0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.timer) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.counter = ($0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.counter + 1) % $0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.imagesSrc.length;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.lastTime = currentTime;
    }
}
function $0f1d4402dffacf5b$export$139d169796c88679(clickedTab) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.clickedTab = clickedTab;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.contentTab = clickedTab.dataset.content;
}
const $0f1d4402dffacf5b$export$f4a3627ab6908969 = function(maxSlides) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.maxSlide = maxSlides.length - 1;
};
const $0f1d4402dffacf5b$export$3f39a45132931174 = (dataSlide)=>{
    console.log(dataSlide);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide = dataSlide;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide;
};
const $0f1d4402dffacf5b$export$1d564d0c739f1c8e = (offset)=>{
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide = ($0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide + offset) % ($0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.maxSlide + 1);
    if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide < 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide = $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.maxSlide;
    return $0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide;
};
const $0f1d4402dffacf5b$export$2350248c4017665c = async function(formData) {
    try {
        const data = fetch((0, $ba30e20475feac5a$export$b4a06ec71d3d433c), {
            method: "POST",
            body: formData
        });
        const res = await data;
        console.log(res);
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$8f2e0aff6bb7bc72 = async function() {
    try {
        const data = await (0, $bd02c871d9c5ba8e$export$2b3ff41fecbef7c8)(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent((0, $ba30e20475feac5a$export$2f54b3a07a353657))}&format=json`);
        const [lat, lon] = [
            data[0].lat,
            data[0].lon
        ];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.map.coords.lat = lat;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.map.coords.lon = lon;
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$472af56da1a74838 = function() {
    const destination = encodeURIComponent((0, $ba30e20475feac5a$export$2f54b3a07a353657));
    const googleMapsURL = `https://www.google.com/maps/dir//${destination}`;
    window.open(googleMapsURL, "_blank");
};


class $3a07c34e115c11c9$export$2e2bcd8739ae039 {
    _data;
    _body = document.body;
    _allSections = document.querySelectorAll(".section");
    _header = document.querySelector(".header");
    _sectionHero = document.querySelector(".section-hero");
    _headerHeight = this._header.getBoundingClientRect().height;
    _btnMobileNav = document.querySelector(".btn-mobile-nav");
    constructor(){
        this.callObs();
        this.callNavObs();
        this.addNavMobileListener();
    }
    // Reusable methods
    clear(parentEl) {
        parentEl.innerHTML = "";
    }
    displaySpinner = function(parentEl) {
        const spinnerEl = `
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    `;
        this.clear(parentEl);
        parentEl.insertAdjacentHTML("afterbegin", spinnerEl);
    };
    displayMessage(parentEl, message = "") {
        const messageEl = `<div class="message"><ion-icon class="msg-icon" name="paper-plane-outline"></ion-icon>
    <span>${message}</span>
  </div>`;
        this.clear(parentEl);
        parentEl.insertAdjacentHTML("afterbegin", messageEl);
    }
    displayError(parentEl, errorMessage = "An error occured") {
        const errorEl = `
    <div class="error"><ion-icon class="msg-icon" name="alert-circle-outline"></ion-icon>
      <span>${errorMessage}</span>
    </div>
    `;
        this.clear(parentEl);
        parentEl.insertAdjacentHTML("afterbegin", errorEl);
    }
    // Sticky Nav
    heroSectionObs(entries) {
        const [entry] = entries;
        this._body.classList.toggle("sticky", !entry.isIntersecting);
    }
    headerObs() {
        return new IntersectionObserver(this.heroSectionObs.bind(this), {
            root: null,
            threshold: 0.2,
            rootMargin: `-${this._headerHeight}px`
        });
    }
    callNavObs() {
        this.headerObs().observe(this._sectionHero);
    }
    // Reveal sections
    revealSection(entries, observer) {
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            entry.target.classList.remove("section--hidden");
            observer.unobserve(entry.target);
        });
    }
    sectionObs() {
        return new IntersectionObserver(this.revealSection.bind(this), {
            root: null,
            threshold: 0.2
        });
    }
    callObs() {
        const observer = this.sectionObs();
        this._allSections.forEach((section)=>{
            section.classList.add("section--hidden");
            observer.observe(section);
        });
    }
    addNavMobileListener() {
        this._btnMobileNav.addEventListener("click", (e)=>{
            e.preventDefault();
            const menuIcon = e.target.closest('.icon-mobile-nav[name="menu-outline"]');
            const closeIcon = e.target.closest('.icon-mobile-nav[name="close-outline"]');
            if (menuIcon) this._header.classList.add("nav-open");
            else if (closeIcon) this._header.classList.remove("nav-open");
        });
    }
}


class $583bc7d19fdc0dd8$var$viewForm extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentEl = document.forms["contact-form"];
    formMsg = this._parentEl.querySelector(".form-msg-container");
    addFormSubmitHandler(handler) {
        this._parentEl.addEventListener("submit", (e)=>{
            e.preventDefault();
            const formData = new FormData(this._parentEl);
            handler(formData);
        });
    }
    formReset() {
        this._parentEl.reset();
    }
}
var $583bc7d19fdc0dd8$export$2e2bcd8739ae039 = new $583bc7d19fdc0dd8$var$viewForm();



class $12525dd19adcac81$var$viewHeroSlider extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".hero-slider");
    _message = "";
    _error = "Images could not be loaded";
    addHandler(handler) {
        window.addEventListener("load", handler);
    }
    getSliderImgs() {
        return this._parentEl.querySelectorAll(".hero-slider-img");
    }
    updateSliderBackground(imageUrl) {
        this._parentEl.style.backgroundImage = `url(${imageUrl})`;
    }
}
var $12525dd19adcac81$export$2e2bcd8739ae039 = new $12525dd19adcac81$var$viewHeroSlider();



class $f1716cb8d8cd3620$var$viewMap extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentEl = document.getElementById("map");
    _map;
    _btnDirections = document.querySelector(".btn-directions");
    addHandler(handler) {
        window.addEventListener("load", handler);
    }
    setView(coords) {
        this._map = L.map("map").setView([
            coords.lat,
            coords.lon
        ], 13);
        L.tileLayer("https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
            maxZoom: 20,
            subdomains: [
                "mt0",
                "mt1",
                "mt2",
                "mt3"
            ]
        }).addTo(this._map);
        L.marker([
            coords.lat,
            coords.lon
        ]).addTo(this._map).bindPopup("PRO TILING DESIGN", {
            closeOnClick: false,
            autoClose: false
        }).openPopup();
    }
    addBtnDirectionHandler(handler) {
        this._btnDirections.addEventListener("click", (e)=>{
            e.preventDefault();
            handler();
        });
    }
}
var $f1716cb8d8cd3620$export$2e2bcd8739ae039 = new $f1716cb8d8cd3620$var$viewMap();



class $0ce162df0fbac024$var$viewSliderComponent extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".slider");
    _dotContainer = this._parentEl.querySelector(".dot-container");
    constructor(){
        super();
        this.createDots();
    }
    addHandler(handler) {
        window.addEventListener("load", handler);
    }
    getSlides() {
        return this._parentEl.querySelectorAll(".slide");
    }
    updateSlide(curSlide) {
        const slides = this.getSlides();
        slides.forEach((slide, index)=>{
            slide.style.transform = `translateX(${(index - curSlide) * 100}%)`;
        });
        this.activateDots(curSlide);
    }
    addSlideBtnListeners(updateSlide) {
        this._parentEl.querySelector(".slider-btn--right").addEventListener("click", ()=>updateSlide(1));
        this._parentEl.querySelector(".slider-btn--left").addEventListener("click", ()=>updateSlide(-1));
        document.addEventListener("keydown", (e)=>{
            if (e.key === "ArrowRight") updateSlide(1);
            else if (e.key === "ArrowLeft") updateSlide(-1);
        });
    }
    addDotListener(updateDot) {
        this._dotContainer.addEventListener("click", (e)=>{
            const dot = e.target.closest(".dot");
            if (!dot) return;
            const dataSlide = dot.dataset.slide;
            updateDot(+dataSlide);
        });
    }
    createDots() {
        const slides = this.getSlides();
        slides.forEach((_, i)=>{
            const dot = `<button class="dot" data-slide="${i}"></button>`;
            this._dotContainer.insertAdjacentHTML("beforeend", dot);
        });
    }
    activateDots(curSlide) {
        const allDots = this._dotContainer.querySelectorAll(".dot");
        allDots.forEach((dot, i)=>{
            if (i === curSlide) dot.classList.add("dot--fill");
            else dot.classList.remove("dot--fill");
        });
    }
}
var $0ce162df0fbac024$export$2e2bcd8739ae039 = new $0ce162df0fbac024$var$viewSliderComponent();



class $a46d756edd82aba6$var$smoothScrollingView extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._addEventListeners();
    }
    _parentEl = document.querySelector(".main-nav-list");
    // _footerLink = document.querySelector('.footer-link');
    _logoImg = document.querySelectorAll(".logo-img");
    _header = document.querySelector(".header");
    _scrollToSection(targetSection) {
        document.querySelector(`.${targetSection}`).scrollIntoView({
            behavior: "smooth"
        });
    }
    _handleClick(e) {
        e.preventDefault();
        const clicked = e.target.closest(".nav-link");
        if (clicked) {
            const targetSection = clicked.dataset.section;
            this._scrollToSection(targetSection);
            this._header.classList.remove("nav-open");
        } else if (e.target.classList.contains("logo-img")) {
            const targetSection = e.target.dataset.section;
            this._scrollToSection(targetSection);
        }
    }
    _addEventListeners() {
        this._parentEl.addEventListener("click", this._handleClick.bind(this));
        this._logoImg.forEach((logo)=>logo.addEventListener("click", this._handleClick.bind(this)));
    }
}
var $a46d756edd82aba6$export$2e2bcd8739ae039 = new $a46d756edd82aba6$var$smoothScrollingView();



class $8bf415fd1abaa0c8$var$viewTabbedComponent extends (0, $3a07c34e115c11c9$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector(".about-box");
    addHandlerTabClick(handler) {
        this._parentEl.addEventListener("click", (e)=>{
            e.preventDefault();
            this.openServicesList(e);
            const clickedTab = e.target.closest(".btn-tab");
            if (!clickedTab) return;
            handler(clickedTab);
        });
    }
    setActiveTab(clickedTab) {
        const tabs = this._parentEl.querySelectorAll(".btn-tab");
        tabs.forEach((tab)=>{
            tab.classList.toggle("btn-tab--active", tab === clickedTab);
        });
    }
    setContentTab(contentTab) {
        console.log(contentTab);
        const tabContent = document.querySelectorAll(".btn-tab-content");
        tabContent.forEach((tabContent)=>tabContent.classList.remove("tab-content--active"));
        document.querySelector(`.${contentTab}`).classList.add("tab-content--active");
        if (contentTab !== "tab-content--2") this._parentEl.querySelector(".services").classList.remove("list-open");
    }
    openServicesList(e) {
        if (e.target.classList.contains("full-services-link")) this._parentEl.querySelector(".services").classList.add("list-open");
        if (e.target.classList.contains("close-icon")) this._parentEl.querySelector(".services").classList.remove("list-open");
    }
}
var $8bf415fd1abaa0c8$export$2e2bcd8739ae039 = new $8bf415fd1abaa0c8$var$viewTabbedComponent();


// Hero slider controller
const $f50bd1f2915ed0f2$var$controlHeroSlider = function() {
    const sliderImgs = (0, $12525dd19adcac81$export$2e2bcd8739ae039).getSliderImgs();
    $0f1d4402dffacf5b$export$404675901f56ec25(sliderImgs);
    function startSliderLoop() {
        $0f1d4402dffacf5b$export$322cd04d2c309b06(performance.now());
        (0, $12525dd19adcac81$export$2e2bcd8739ae039).updateSliderBackground($0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.imagesSrc[$0f1d4402dffacf5b$export$ca000e230c0caa3e.heroSlider.counter]);
        requestAnimationFrame(startSliderLoop);
    }
    startSliderLoop();
};
// Tabbed component controller
const $f50bd1f2915ed0f2$var$controlTabs = function(clickedTab) {
    $0f1d4402dffacf5b$export$139d169796c88679(clickedTab);
    (0, $8bf415fd1abaa0c8$export$2e2bcd8739ae039).setActiveTab($0f1d4402dffacf5b$export$ca000e230c0caa3e.clickedTab);
    (0, $8bf415fd1abaa0c8$export$2e2bcd8739ae039).setContentTab($0f1d4402dffacf5b$export$ca000e230c0caa3e.contentTab);
};
// Slider Component Controller
function $f50bd1f2915ed0f2$var$controlSlider() {
    const maxSlides = (0, $0ce162df0fbac024$export$2e2bcd8739ae039).getSlides();
    $0f1d4402dffacf5b$export$f4a3627ab6908969(maxSlides);
    const dotHandler = (dataSlide)=>{
        $0f1d4402dffacf5b$export$3f39a45132931174(dataSlide);
        (0, $0ce162df0fbac024$export$2e2bcd8739ae039).updateSlide($0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide);
    };
    (0, $0ce162df0fbac024$export$2e2bcd8739ae039).addDotListener(dotHandler);
    const updateSlide = (offset)=>{
        $0f1d4402dffacf5b$export$1d564d0c739f1c8e(offset);
        (0, $0ce162df0fbac024$export$2e2bcd8739ae039).updateSlide($0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide);
    };
    (0, $0ce162df0fbac024$export$2e2bcd8739ae039).addSlideBtnListeners(updateSlide);
    (0, $0ce162df0fbac024$export$2e2bcd8739ae039).updateSlide($0f1d4402dffacf5b$export$ca000e230c0caa3e.sliderComponent.curSlide);
}
// Control form
const $f50bd1f2915ed0f2$var$controlForm = async function(formData) {
    try {
        (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).displaySpinner((0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formMsg);
        await $0f1d4402dffacf5b$export$2350248c4017665c(formData);
        (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).displayMessage((0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formMsg, "Message succesfully sent");
        setTimeout(function() {
            (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).clear((0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formMsg);
        }, (0, $ba30e20475feac5a$export$196440f71ed9f601));
        (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formReset();
    } catch (err) {
        (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).displayError((0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formMsg, "Message failed to send");
        setTimeout(function() {
            (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).clear((0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formMsg);
        }, (0, $ba30e20475feac5a$export$196440f71ed9f601));
        (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).formReset();
    }
};
// Map controller
const $f50bd1f2915ed0f2$var$mapController = async function() {
    try {
        await $0f1d4402dffacf5b$export$8f2e0aff6bb7bc72();
        (0, $f1716cb8d8cd3620$export$2e2bcd8739ae039).setView($0f1d4402dffacf5b$export$ca000e230c0caa3e.map.coords);
        (0, $f1716cb8d8cd3620$export$2e2bcd8739ae039).addBtnDirectionHandler($0f1d4402dffacf5b$export$472af56da1a74838);
    } catch (err) {
        (0, $f1716cb8d8cd3620$export$2e2bcd8739ae039).displayError();
    }
};
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $12525dd19adcac81$export$2e2bcd8739ae039).addHandler($f50bd1f2915ed0f2$var$controlHeroSlider);
    (0, $8bf415fd1abaa0c8$export$2e2bcd8739ae039).addHandlerTabClick($f50bd1f2915ed0f2$var$controlTabs);
    (0, $0ce162df0fbac024$export$2e2bcd8739ae039).addHandler($f50bd1f2915ed0f2$var$controlSlider);
    (0, $583bc7d19fdc0dd8$export$2e2bcd8739ae039).addFormSubmitHandler($f50bd1f2915ed0f2$var$controlForm);
    (0, $f1716cb8d8cd3620$export$2e2bcd8739ae039).addHandler($f50bd1f2915ed0f2$var$mapController);
};
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=index.459704d0.js.map
